export const updateObject = (oldObject, updatedProperties) => {
  var obj = {
    ...oldObject,
    ...updatedProperties,
  };
  return obj;
};
